// Read Stamped's rendered badge; do not substitute Shopify metafield totals.
if (!customElements.get('card-stamped-rating')) {
  customElements.define('card-stamped-rating', class extends HTMLElement {
    connectedCallback() {
      this.observer?.disconnect();
      const source = this.querySelector('.stamped-product-reviews-badge');
      if (!source) return;
      this.stars = this.querySelectorAll('[data-rating-star]');
      this.countText = this.querySelector('[data-rating-count]');
      this.ratingRow = this.querySelector('[role="img"]');
      this.lastRating = undefined;
      this.lastCount = undefined;
      this.observer = new MutationObserver(() => this.updateRating());
      this.observer.observe(source, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-rating', 'data-reviews']
      });
      this.updateRating();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    updateRating() {
      const badge = this.querySelector('.stamped-badge[data-rating]');
      const caption = this.querySelector('.stamped-badge-caption[data-reviews]');
      if (!caption || !caption.dataset.reviews.trim()) return;
      const count = Number(caption.dataset.reviews);
      const parseRating = raw => raw != null && raw.trim() !== '' ? Number(raw) : NaN;
      const captionRating = parseRating(caption.dataset.rating);
      const value = Number.isFinite(captionRating) ? captionRating : parseRating(badge?.dataset.rating);
      if (!Number.isFinite(count) || count < 0 || !Number.isFinite(value)) return;
      const rating = count > 0 ? Math.min(5, Math.max(0, value)) : 0;
      if (rating === this.lastRating && count === this.lastCount) return;
      this.stars.forEach((star, index) => {
        const unfilled = `${Math.round((1 - Math.min(1, Math.max(0, rating - index))) * 10000) / 100}%`;
        if (star.style.getPropertyValue('--rating-star-unfilled') !== unfilled) {
          star.style.setProperty('--rating-star-unfilled', unfilled);
        }
      });
      this.countText.textContent = `${rating} (${count})`;
      this.ratingRow.setAttribute('aria-label', `${rating} out of 5 stars, ${count} reviews`);
      this.lastRating = rating;
      this.lastCount = count;
    }
  });
}
